import type { AllRouteEndpoints } from "../routeTypes";

export const getCompaniesCompanyIdDevelopersDeveloperIdCacheKey = "/companies/:company_id/developers/:developer_id";
export const getDeveloeprsTableCacheKey = "/companies/:company_id/developers/table";

export const companiesCompanyIdDevelopersDeveloperIdCacheKeys: AllRouteEndpoints[] = [
  // "/companies/:company_id/developers",
  getCompaniesCompanyIdDevelopersDeveloperIdCacheKey,
  getDeveloeprsTableCacheKey,
];
